import { render, staticRenderFns } from "./ZjgwContent.vue?vue&type=template&id=14fa0165&scoped=true&"
import script from "./ZjgwContent.vue?vue&type=script&lang=js&"
export * from "./ZjgwContent.vue?vue&type=script&lang=js&"
import style0 from "./ZjgwContent.vue?vue&type=style&index=0&id=14fa0165&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa0165",
  null
  
)

export default component.exports